import { createContext } from "react";
import EmployeeActionsContextInterface from "./types";

const EmployeeActionsContext = createContext<EmployeeActionsContextInterface>({
  createNewEmployee: () => {},
  createNewEmployeeIsLoading: false,

  editEmployeeDetails: () => {},
  editEmployeeDetailsIsLoading: false,

  downloadEmployeeTemplate: () => {},
  downloadEmployeeTemplateIsLoading: false,

  uploadMultipleEmployees: () => {},
  uploadMultipleEmployeesIsLoading: false,

  deleteEmployeesById: () => {},
  deleteEmployeesByIdIsLoading: false,

  modifyEmployeesBenefitPlan: () => {},
  modifyEmployeesBenefitPlanIsLoading: false,

  modifyEmployeesTaxRegime: () => {},
  modifyEmployeesTaxRegimeIsLoading: false,

  inviteUploadingEmployees: () => {},
  inviteUploadingEmployeesIsLoading: false,

  deliverBagToEmployeesIsLoading: false,
});

export default EmployeeActionsContext;
